import actions from '@/core/store/itens/actions'
import mutations from '@/core/store/itens/mutations'
import state from '@/core/store/itens/state'

export default {
	actions,
	mutations,
	state,
}
